// extracted by mini-css-extract-plugin
export default {"container":"note_container__NL3YL","expanded":"note_expanded__sN+2m","textarea":"note_textarea__k4pt2","saveBtn":"note_saveBtn__sbJPQ"};